import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '../core/service/user.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2'

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {

  constructor(
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  signup(f: NgForm): void {
    if( f.value.password !== f.value.confirm_password ){
      swal({
        title: 'ユーザー登録失敗',
        text: 'パスワードが一致しません。',
        type: 'error',
        confirmButtonText: 'OK'
      })
      return;
    }
    // if(!f.value.displayName){
    //   swal({
    //     title: 'ユーザー登録失敗',
    //     text: 'ユーザー名を入力してください。',
    //     type: 'error',
    //     confirmButtonText: 'OK'
    //   })
    //   return;
    // }
    // this.userService.create(f.value.email, f.value.password, f.value.displayName);
    this.userService.create(f.value.email, f.value.password);
    // this.router.navigate(['/users/new'])
  }

}


// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/sign-up/sign-up.component.ts